import { formatNumber } from './parsing';

// Centraliserad copy för pris-etiketter. Ändra här för att uppdatera texten överallt.
export function getOfferPriceLabel({
    isOwnOffer,
    hasPrice = true,
    listPrice = null,
}: {
    isOwnOffer: boolean;
    hasPrice?: boolean;
    listPrice?: number | null;
}) {
    if (hasPrice) {
        return isOwnOffer ? 'Ni erbjuder' : 'Ni erbjuds';
    }

    return listPrice ? 'Riktpris' : 'Saknar riktpris';
}

export function getOfferPriceText({
    listPrice,
    price,
    isOwnOffer
}: {
    listPrice: number | null;
    price: number | null;
    isOwnOffer: boolean;
}) {
    if (price) {
        return `${getOfferPriceLabel({ isOwnOffer, hasPrice: true })} ${formatNumber(price, 'SEK')}`;
    }

    return listPrice
        ? `Riktpris ${formatNumber(listPrice, 'SEK')}`
        : 'Saknar riktpris';
}
